import configs from 'configs';
import { isEmpty } from 'lodash';
import { useEffect, useState } from 'react';

// TODO: uncommit when deploy
import { useActions } from 'hooks/useActions';
import { useLiff } from 'providers/Liff';
import { authProfile } from 'store/actions/auth';
import { liffAuthAxiosClient } from 'utils/axios';
import { goOA } from 'utils/methods';
import Context from './Context';

const { stage } = configs;

async function getClientProfiles(liff) {
    try {
        const profile = await liff.getProfile().catch((error) => {
            liff.logout();
            liff.login({ redirectUri: window.location.href });
            return false;
        });

        if (!profile) return { error: true };
        const userId = profile.userId;
        const accessToken = liff.getAccessToken();
        liffAuthAxiosClient(accessToken);

        if (configs.enableProfilePlus) {
            const profilePlus = liff.getDecodedIDToken() || {};
            profile.phone = (profilePlus.phone_number || '').replace('+886', '0');
            profile.firstName = profile.displayName;
        }

        return { profile, accessToken, userId };
    } catch (error) {
        return { error };
    }
}

let refreshingClient = false;
const Provider = ({ children }) => {
    const [auth, setAuth] = useState({});
    const [profile, setProfile] = useState({});
    const { liff, ready } = useLiff();
    const [actionAuth] = useActions([authProfile]);
    const queryParams = new URLSearchParams(window.location.search);
    const env = queryParams.get('env');

    const validAuth = auth.userId && auth.accessToken && !isEmpty(profile);

    const refreshClient = async () => {
        if (refreshingClient) return;
        refreshingClient = true;
        const { profile, accessToken, userId, error } = await getClientProfiles(liff);
        refreshingClient = false;
        if (isEmpty(profile) || error) {
            return { err: true };
        }
        actionAuth(profile);
        setProfile(profile);
        setAuth({ accessToken, userId });
        return { err: false };
    };

    useEffect(() => {
        console.log(liff, ready);
        if (!liff || !ready) return;

        // TODO:
        if (stage !== 'development' && !liff.isInClient() && env !== 'dev') return goOA();
        if (stage !== 'development' && !liff.isLoggedIn() && env !== 'dev') {
            return liff.login({ redirectUri: window.location.href });
        }
        refreshClient();
    }, [liff, ready]);

    const props = {
        auth,
        profile,
        validAuth
    };

    return <Context.Provider value={{ ...props }}>{children}</Context.Provider>;
};

export default Provider;
